export default __webpack_public_path__ + "static/media/409.1dc0ea48.png";